import React, {useEffect, useState} from 'react';
import { AppBar, Toolbar, Grid, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import { NestedMenuItem } from 'mui-nested-menu';

import styles from './styles.module.scss';
import StandardMenuItem from './StandardMenuItem';
import StandardNavigationButton from './StandardNavigationButton';
import {clearSelectedUser, getNextGenSSOURL, logOut} from '@user/sagas';
import Logo from '../Logo';
import history from '@utils/history';
import { displayErrorMessage } from '@utils/displayErrorMessage';
import config from '@src/config';
import {
  getUserRole,
  hasAdminRole,
  hasSettlementsCoordinatorRole,
  hasSupervisorRole,
  isAllowedByRoles,
  isJustDataOperations,
  isPartner,
  USER_ROLE
} from '@utils/authorisation';
import { displayNotification } from '@utils/snackbarUtils';
import ActionTimer from '../ActionTimer';
import { setIsPartnerCustomerMode } from '@user/reducers';
import ReferFriendModal from "@common/components/ReferFriendModal";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { isFeatureEnabled } from "@utils/helpers";
import AvTimerOutlinedIcon from "@mui/icons-material/AvTimerOutlined";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DashboardIcon from '@mui/icons-material/Dashboard';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import queryString from "query-string";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import StandardNavigationSubmenu from "@common/components/MainLayout/StandardNavigationSubmenu";


const MainHeader = ({ location }) => {
  const anchorRef = React.useRef(null);
  const anchorHeaderRef = React.useRef(null);

  const { openRaf } = queryString.parse(location.search);

  const hookLocation = useLocation();
  const hookHistory = useHistory();

  const dispatch = useDispatch();
  const { user, selectedUser, isPartnerCustomerMode } = useSelector(state => state.user);
  const { headerType } = useSelector(state => state.common);
  const dimensions = useSelector(state => state.dimensions);
  const { featureFlags } = useSelector(state => state.featureFlags);

  const [open, setOpen] = React.useState(false);
  const [userRole, setUserRole] = React.useState(undefined);
  const [mode, setMode] = React.useState(undefined);
  const [effectiveUser, setEffectiveUser] = React.useState(undefined);
  const [openReferFriendModal, setOpenReferFriendModal] = useState(false);

  const [isEffectivelyCustomer, setIsEffectivelyCustomer] = useState(false);
  const [isActionsNavigationItemRendered, setIsActionsNavigationItemRendered] = useState(false);
  const [isCustomersNavigationItemRendered, setIsCustomersNavigationItemRendered] = useState(false);
  const [isJourneysNavigationItemRendered, setIsJourneysNavigationItemRendered] = useState(false);
  const [isDocumentsNavigationItemRendered, setIsDocumentsNavigationItemRendered] = useState(false);
  const [isTeamNavigationItemRendered, setIsTeamNavigationItemRendered] = useState(false);
  const [isOpenNextGenRendered, setIsOpenNextGenRendered] = useState(false);
  const [isLendersRendered, setIsLendersRendered] = useState(false);
  const [isDealsManagementRendered, setIsDealsManagementRendered] = useState(false);
  const [isAccountAndTeamRendered, setIsAccountAndTeamRendered] = useState(false);
  const [isAccountsRendered, setIsAccountsRendered] = useState(false);
  const [isActivityNavigationItemRendered, setIsActivityNavigationItemRendered] = useState(false);

  useEffect(() => {
    if (!!openRaf) {
      setOpenReferFriendModal(true);

      const queryParams = new URLSearchParams(hookLocation.search);

      if (queryParams.has('openRaf')) {
        queryParams.delete('openRaf')
        hookHistory.replace({
          search: queryParams.toString(),
        })
      }
    }
  }, [openRaf]); //eslint-disable-line

  useEffect(() => {
    const handleLoggingOut = (e) => {
      if (e.key === 'shouldLogOut') {
        const shouldLogOutItem = localStorage.getItem('shouldLogOut');
        const explicitlyLoggedOutItem = sessionStorage.getItem('explicitlyLoggedOut');
        const shouldLogOutDate = shouldLogOutItem ? Number(shouldLogOutItem) : undefined;
        const explicitlyLoggedOutDate = explicitlyLoggedOutItem ? Number(explicitlyLoggedOutItem) : undefined;
        const shouldLogOutOutdated = !shouldLogOutDate || isNaN(shouldLogOutDate) || Date.now() - shouldLogOutDate > 1000 * 5; //5 seconds
        const explicitlyLoggedOutDateOutdated = !explicitlyLoggedOutDate || isNaN(explicitlyLoggedOutDate) || Date.now() - explicitlyLoggedOutDate > 1000 * 5; //5 seconds
        if (!shouldLogOutOutdated && explicitlyLoggedOutDateOutdated) {
          dispatch(logOut({}));
        } else {
          if (shouldLogOutOutdated && !!shouldLogOutItem) localStorage.removeItem('shouldLogOut');
        }
      }

      if (e.key === 'shouldRedirectToDashboard') {
        const shouldRedirectToDashboardItem = localStorage.getItem('shouldRedirectToDashboard');
        const explicitlyLoggedInItem = sessionStorage.getItem('explicitlyLoggedIn');
        const shouldRedirectToDashboardDate = shouldRedirectToDashboardItem ? Number(shouldRedirectToDashboardItem) : undefined;
        const explicitlyLoggedInDate = explicitlyLoggedInItem ? Number(explicitlyLoggedInItem) : undefined;
        const shouldRedirectToDashboardOutdated = !shouldRedirectToDashboardDate || isNaN(shouldRedirectToDashboardDate) || Date.now() - shouldRedirectToDashboardDate > 1000 * 5; //5 seconds
        const explicitlyLoggedInDateOutdated = !explicitlyLoggedInDate || isNaN(explicitlyLoggedInDate) || Date.now() - explicitlyLoggedInDate > 1000 * 5; //5 seconds
        if (!shouldRedirectToDashboardOutdated && explicitlyLoggedInDateOutdated) {
          sessionStorage.setItem('explicitlyLoggedIn', (Date.now()).toString());
          window.location.reload(false);
        } else {
          if (shouldRedirectToDashboardOutdated && !!shouldRedirectToDashboardItem) localStorage.removeItem('shouldRedirectToDashboard');
        }
      }
    };

    window.addEventListener('storage', handleLoggingOut)
    return function cleanup() {
      window.removeEventListener('storage', handleLoggingOut)
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    setUserRole(getUserRole(user));
  }, [user]); // eslint-disable-line

  useEffect(() => {
    if (!userRole || userRole === USER_ROLE.Customer) {
      setMode('customer');
    } else if (userRole !== USER_ROLE.Customer) {
      if (isPartner(user)) {
        setMode('partner');//isPartnerCustomerMode
      } else if (selectedUser?.id) {
        setMode('selected');
      } else {
        setMode('specialist');
      }
    }
  }, [userRole, selectedUser, user, isPartnerCustomerMode]); // eslint-disable-line

  useEffect(() => {
    setEffectiveUser(selectedUser ?? user);
  }, [user, selectedUser]); // eslint-disable-line

  useEffect(() => {
    if (!!user && !!effectiveUser && !!mode && !!userRole) {
      const nonCustomerOrDataOperationsRoles = [
        USER_ROLE.Admin,
        USER_ROLE.OperationsManager,
        USER_ROLE.Supervisor,
        USER_ROLE.SettlementsCoordinator,
        USER_ROLE.Conveyancer,
        USER_ROLE.Specialist,
        USER_ROLE.Audit,
        USER_ROLE.Partner_Admin,
        USER_ROLE.Partner_Supervisor,
        USER_ROLE.Partner_Member
      ];
      const effectivelyCustomer = userRole === USER_ROLE.Customer || (mode === 'selected' && !isAllowedByRoles(effectiveUser, nonCustomerOrDataOperationsRoles)) || !!isPartnerCustomerMode;

      setIsEffectivelyCustomer(effectivelyCustomer);
      setIsActionsNavigationItemRendered(isAllowedByRoles(
          effectiveUser,
          [USER_ROLE.Admin, USER_ROLE.OperationsManager, USER_ROLE.Supervisor, USER_ROLE.SettlementsCoordinator, USER_ROLE.Conveyancer, USER_ROLE.Specialist, USER_ROLE.Audit]
        ) && mode !== 'selected'
      );
      setIsActivityNavigationItemRendered(
        isAllowedByRoles(
          effectiveUser,
          [USER_ROLE.Admin, USER_ROLE.OperationsManager, USER_ROLE.Supervisor, USER_ROLE.SettlementsCoordinator, USER_ROLE.Conveyancer, USER_ROLE.Specialist, USER_ROLE.Audit]
        ) && mode !== 'selected'
      );
      setIsCustomersNavigationItemRendered(
        isAllowedByRoles(user, nonCustomerOrDataOperationsRoles)
        && (mode !== 'selected' || isAllowedByRoles(effectiveUser, nonCustomerOrDataOperationsRoles))
        && !isPartnerCustomerMode
      );
      setIsJourneysNavigationItemRendered(!isJustDataOperations(user));
      setIsDocumentsNavigationItemRendered(!!effectivelyCustomer);
      setIsTeamNavigationItemRendered(!!effectivelyCustomer);
      setIsOpenNextGenRendered((hasSupervisorRole(user) || hasSettlementsCoordinatorRole(user) || hasAdminRole(user)));
      setIsLendersRendered(isAllowedByRoles(
        effectiveUser,
        [USER_ROLE.Admin, USER_ROLE.OperationsManager, USER_ROLE.Supervisor, USER_ROLE.SettlementsCoordinator, USER_ROLE.Specialist, USER_ROLE.Audit, USER_ROLE.DataOperations]
      ));
      setIsDealsManagementRendered(isAllowedByRoles(
        effectiveUser,
        [USER_ROLE.Admin, USER_ROLE.DataOperations]
      ));
      setIsAccountAndTeamRendered(isAllowedByRoles(
        effectiveUser,
        [USER_ROLE.Partner_Admin]
      ));
      setIsAccountsRendered(isAllowedByRoles(
        effectiveUser,
        [USER_ROLE.Admin]
      ));
    }
  }, [user, effectiveUser, userRole, mode, isPartnerCustomerMode, ]); // eslint-disable-line

  const touchOpenContainerProps = {
    onTouchStart: (event) => {
      event.currentTarget.focus();
    },
    onClick: (event) => {
      event.currentTarget.focus();
    },
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event, destination, externalUrl) => {
    if (destination) {
      history.push(destination);
      setOpen(false);
    } else if (externalUrl) {
      setOpen(false);
      const win = window.open(externalUrl, '_blank');
      if (win) win.focus();
    }

    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    if (anchorHeaderRef.current && anchorHeaderRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleReferringAFriend = (event) => {
    setOpenReferFriendModal(true);
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const doClearSelectedUser = () => {
    dispatch(clearSelectedUser({
      onSuccess: () => { history.push('/dashboard'); },
      onError: () => { displayErrorMessage(null, 'Unable to clear selected user'); }
    }));
  };

  const goToNextGenPage = (e) => {
    handleClose(e);
    displayNotification.success('The destination page will be opened in a new tab');
    dispatch(getNextGenSSOURL({
      onSuccess: (data) => {
        handleClose(e, null, data);
      },
      onError: (data) => {
        displayErrorMessage(data, 'Unable to get NextGen SSO URL');
      }
    }));
  };

  const renderUserAccountLabel = () => {
    return (
      <div>
        {user?.photo ? (
          <img
            width="42"
            height="42"
            className={`${styles.accountName}`}
            src={user.photo}
            alt="user avatar"
            data-testid="button-main-header-user-avatar"
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            onClick={handleToggle}
          />
        ) : (
          <div
            className={styles.accountName}
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            data-testid="button-main-header-user-avatar"
            onClick={handleToggle}
          >
            <PersonIcon />
          </div>
        )}
        <Popper
          open={open && dimensions.isScreenBiggerSM}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          placement="bottom"
          className={styles.userMenuPopper}
          arrow={{ enabled: true }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: 'center top' }}
            >
              <Paper className={styles.userMenuPaper} elevation={1}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <MenuItem className={`${styles.menuItem} ${styles.info}`} disableRipple disableTouchRipple>
                      <span>Signed in as{' '}<span className={styles.emphasis}>{user?.name ?? 'unknown'}</span></span>
                    </MenuItem>

                    {isPartner(effectiveUser) && (
                      <StandardMenuItem
                        label={`Switch to ${isPartnerCustomerMode ? 'partner' : 'customer'} view`}
                        action={(e) => {
                          setOpen(false);
                          if (!isPartnerCustomerMode) localStorage.setItem('PARTNERS-CUSTOMER-MODE', 'true');
                          else localStorage.removeItem('PARTNERS-CUSTOMER-MODE');
                          dispatch(setIsPartnerCustomerMode(!isPartnerCustomerMode));
                          handleClose(e, '/dashboard');
                        }}
                      />
                    )}

                    {!!isEffectivelyCustomer && (
                      <>
                        <StandardMenuItem
                          label="Journeys"
                          icon={<AvTimerOutlinedIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/journeys'); }}
                          link="/journeys"
                          topIconPos="6px"
                        />
                        <StandardMenuItem
                          label="Documents"
                          icon={<LibraryBooksIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/documents'); }}
                          link="/documents"
                          topIconPos="6px"
                        />
                        <StandardMenuItem
                          label="Team"
                          icon={<PeopleOutlinedIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/team'); }}
                          link="/team"
                          topIconPos="5px"
                        />
                      </>
                    )}

                    {(userRole === USER_ROLE.Customer && !!isFeatureEnabled(featureFlags, 'isReferFriendsInvitesActive')) && (
                      <StandardMenuItem
                        label="Refer a friend"
                        icon={<CardGiftcardIcon />}
                        action={(e) => { e.preventDefault(); handleReferringAFriend(e); }}
                        topIconPos="2px"
                      />
                    )}

                    {mode === 'specialist' && (<>
                      <NestedMenuItem
                        className={`${styles.nestedMenuItem}`}
                        disableRipple
                        disableTouchRipple
                        onClick={() => {}}
                        label={<><span style={{ marginRight: '8px', position: 'relative', top: '4px' }}><DashboardIcon /></span>Utilities</>}
                        parentMenuOpen={!!open}
                        data-testid={`menuitem-user-menu-main-header-utilities`}
                      >
                        <StandardMenuItem
                          label="Deals finder"
                          action={(e) => { e.preventDefault(); handleClose(e, '/find-deals/find-deal-specialist'); }}
                          link="/find-deals/find-deal-specialist"
                          isNested
                        />
                        {!isJustDataOperations(effectiveUser) && (
                          <StandardMenuItem
                            label="Property reports"
                            action={(e) => { e.preventDefault(); handleClose(e, '/property-reports'); }}
                            link="/property-reports"
                            isNested
                          />
                        )}
                      </NestedMenuItem>
                      <NestedMenuItem
                        className={`${styles.nestedMenuItem}`}
                        disableRipple
                        disableTouchRipple
                        onClick={() => {}}
                        label={<><span style={{ marginRight: '8px', position: 'relative', top: '5px' }}><CalculateOutlinedIcon /></span>Calculators</>}
                        parentMenuOpen={!!open}
                        data-testid={`menuitem-user-menu-main-header-calculators`}
                      >
                        <StandardMenuItem
                          label="Stamp duty calculator"
                          action={(e) => { e.preventDefault(); handleClose(e, '/calculators/stamp-duty'); }}
                          link="/calculators/stamp-duty"
                          isNested
                        />
                        <StandardMenuItem
                          label="Loan repayment calculator"
                          action={(e) => { e.preventDefault(); handleClose(e, '/calculators/loan-repayment'); }}
                          link="/calculators/loan-repayment"
                          isNested
                        />
                        <StandardMenuItem
                          label="Extra repayment calculator"
                          action={(e) => { e.preventDefault(); handleClose(e, '/calculators/extra-repayment'); }}
                          link="/calculators/extra-repayment"
                          isNested
                        />
                        <StandardMenuItem
                          label="Income tax calculator"
                          action={(e) => { e.preventDefault(); handleClose(e, '/calculators/income-taxes'); }}
                          link="/calculators/income-taxes"
                          isNested
                        />
                        <StandardMenuItem
                          label="Offset account calculator"
                          action={(e) => { e.preventDefault(); handleClose(e, '/calculators/offset-account'); }}
                          link="/calculators/offset-account"
                          isNested
                        />
                        <StandardMenuItem
                          label="Equity calculator"
                          action={(e) => { e.preventDefault(); handleClose(e, '/calculators/equity-calculator'); }}
                          link="/calculators/equity-calculator"
                          isNested
                        />
                        <StandardMenuItem
                          label="Rate change calculator"
                          action={(e) => { e.preventDefault(); handleClose(e, '/calculators/rate-change-calculator'); }}
                          link="/calculators/rate-change-calculator"
                          isNested
                        />
                      </NestedMenuItem>
                    </>)}

                    {(!!isOpenNextGenRendered || !!isLendersRendered || !!isDealsManagementRendered) && (<>
                      <NestedMenuItem
                        className={`${styles.nestedMenuItem}`}
                        disableRipple
                        disableTouchRipple
                        onClick={() => {}}
                        label={<><span style={{ marginRight: '8px', position: 'relative', top: '5px' }}><PermDataSettingIcon /></span>Services</>}
                        parentMenuOpen={!!open}
                        data-testid={`menuitem-user-menu-main-header-services`}
                      >
                        {!!isOpenNextGenRendered && (
                          <StandardMenuItem
                            label="Open NextGen"
                            action={(e) => { goToNextGenPage(e); }}
                            isNested
                          />
                        )}
                        {!!isLendersRendered && (
                          <StandardMenuItem
                            label="Lenders"
                            action={(e) => { e.preventDefault(); handleClose(e, '/lenders'); }}
                            link="/lenders"
                            isNested
                          />
                        )}
                        {!!isDealsManagementRendered && (
                          <StandardMenuItem
                            label="Deals management"
                            action={(e) => { e.preventDefault(); handleClose(e, '/deals-management'); }}
                            link="/deals-management"
                            isNested
                          />
                        )}
                      </NestedMenuItem>
                    </>)}

                    {!!isAccountAndTeamRendered && (
                      <StandardMenuItem
                        label="Account & Team"
                        icon={<SupervisorAccountIcon />}
                        action={(e) => { e.preventDefault(); handleClose(e, '/partner-account-edit'); }}
                        link="/partner-account-edit"
                        topIconPos="6px"
                      />
                    )}
                    {!!isAccountsRendered && (
                      <>
                        <StandardMenuItem
                          label="Accounts"
                          icon={<SupervisorAccountIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/accounts'); }}
                          link="/accounts"
                          topIconPos="6px"
                        />
                        <StandardMenuItem
                          label="Users"
                          icon={<PeopleOutlinedIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/users'); }}
                          link="/users"
                          topIconPos="6px"
                        />
                      </>
                    )}

                    <StandardMenuItem
                      label="Profile"
                      icon={<PersonOutlineIcon />}
                      action={(e) => { e.preventDefault(); handleClose(e, '/profile'); }}
                      link="/profile"
                      topIconPos="5px"
                    />
                    <StandardMenuItem
                      label="Log Out"
                      action={(e) => { setOpen(false); dispatch(logOut({})); handleClose(e); }}
                      className={styles.logout}
                    />
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  };

  return (
      <>
        <AppBar
          className={`${styles.appBar} ${headerType === 'registrationWizard' ? styles.wizard : ''}`}
          position={headerType === 'registrationWizard' ? 'static' : 'fixed'}
        >
          <Toolbar className={
            `${styles.toolBar} ${dimensions?.isScreenLessLG ? styles.mobile : ''} 
            ${headerType === 'wizard' || headerType === 'registrationWizard' ? styles.wizard : ''}`
          } ref={anchorHeaderRef}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center" >
              <Grid item>
                <Grid container alignContent="center" direction={dimensions.isScreenLessMD ? 'column' : 'row'}>
                  <Grid item>
                    <Logo
                      to={headerType === 'scheduled' ? undefined : '/'}
                      externalLink={!user && headerType === 'registrationWizard' ? config.EXTERNAL_INFO_SITE : undefined}
                      clickAction={() => { setOpen(false); }}
                      height={26}
                      dataTestId={!user && headerType === 'registrationWizard' ? 'link-main-header-logo-external' : 'link-main-header-logo'}
                    />
                  </Grid>
                  {(userRole !== USER_ROLE.Customer) && mode === 'specialist' && (<Grid item className={styles.specialistLogin}>
                    {userRole === USER_ROLE.OperationsManagerWithCurrentJourneyEditRights ? USER_ROLE.OperationsManager : userRole}
                  </Grid>)}
                  {(userRole !== USER_ROLE.Customer) && mode === 'selected' && (<Grid item className={styles.specialistLogin}>
                    viewing as{isPartner(selectedUser) && !isPartnerCustomerMode ? ' Partner' : ''} <span className={styles.emphasis}>{selectedUser?.name} {selectedUser?.surname}</span>
                    {' '}<span className={styles.close} data-testid="button-main-header-clear-selected-user" onClick={() => doClearSelectedUser()}>[clear]</span>
                  </Grid>)}
                  {(userRole !== USER_ROLE.Customer) && mode === 'partner' && !isPartnerCustomerMode && (<Grid item className={styles.specialistLogin}>
                    Partner
                  </Grid>)}
                </Grid>
              </Grid>
              {headerType !== 'wizard' && headerType !== 'registrationWizard' && headerType !== 'scheduled' && (
                <Grid item>
                  {dimensions.isScreenBiggerSM ? (<>
                    <Grid
                      container
                      className={styles.navControlWrapper}
                      justifyContent="flex-end"
                      alignContent="center"
                      alignItems="center"
                    >
                      <ActionTimer />
                      {!!isCustomersNavigationItemRendered && (
                        <StandardNavigationButton
                          label="CUSTOMERS"
                          link="/customers-dashboard"
                          action={(e) => { e.preventDefault(); history.push('/customers-dashboard'); }}
                        />
                      )}
                      {!!isJourneysNavigationItemRendered && (
                        <StandardNavigationButton
                          label="JOURNEYS"
                          link={isEffectivelyCustomer ? '/journeys' : '/journeys-dashboard'}
                          action={(e) => { e.preventDefault(); history.push(isEffectivelyCustomer ? '/journeys' : '/journeys-dashboard'); }}
                        />
                      )}
                      {!!isDocumentsNavigationItemRendered && (
                        <StandardNavigationButton
                          label="DOCUMENTS"
                          link="/documents"
                          action={(e) => { e.preventDefault(); history.push('/documents'); }}
                        />
                      )}
                      {!!isDocumentsNavigationItemRendered && (
                        <StandardNavigationButton
                          label="TEAM"
                          link="/team"
                          action={(e) => { e.preventDefault(); history.push('/team'); }}
                        />
                      )}
                      {!!isActionsNavigationItemRendered && (
                        <StandardNavigationSubmenu
                          label="WORKFLOW"
                          items={[
                            { label: 'ACTIONS', link: '/actions', action: (e) => { e.preventDefault(); history.push('/actions'); } },
                            { label: 'ACTIVITY', link: '/journeys-activity', action: (e) => { e.preventDefault(); history.push('/journeys-activity'); } }
                          ]}
                        />
                      )}
                      {renderUserAccountLabel()}
                    </Grid>
                  </>) : (<Grid
                    item
                    container
                    className={styles.navControlWrapper}
                    justifyContent="flex-end"
                    alignContent="center"
                    alignItems="center"
                  >
                    <ActionTimer />
                    {open ? (
                      <CloseIcon onClick={handleToggle} className={styles.mobileMenuToggleIcon} id={'mobile-nav-menu-close'} data-testid="button-main-header-mobile-menu-close" />
                    ) : (
                      <MenuIcon onClick={handleToggle} className={styles.mobileMenuToggleIcon} id={'mobile-nav-menu-open'} data-testid="button-main-header-mobile-menu-open" />
                    )}
                  </Grid>)}
                </Grid>
              )}
              {(headerType === 'wizard' || headerType === 'registrationWizard' || headerType === 'scheduled') && (
                <ActionTimer noMargin />
              )}
              {/*{headerType === 'registrationWizard' && !user && (
                <Grid item>
                  <Grid
                    container
                    className={styles.navControlWrapper}
                    justifyContent="flex-end"
                    alignContent="center"
                    alignItems="center"
                  >
                    <Button
                      color="inherit"
                      onClick={() => history.push('/')}
                      className={`${styles.navButton} ${styles.signInWizard}`}
                    >
                      SIGN IN
                    </Button>
                  </Grid>
                </Grid>
              )}*/}
            </Grid>
          </Toolbar>
          <Popper
            open={open && !dimensions.isScreenBiggerSM}
            anchorEl={anchorHeaderRef.current}
            role={undefined}
            transition
            disablePortal
            placement="bottom"
            className={styles.mobileMenuPopper}
          >
            {({ TransitionProps }) => (
              <Grow
                {...TransitionProps}
                style={{ transformOrigin: 'center top' }}
              >
                <Paper className={styles.mobileMenuPaper} elevation={0}>
                  <ClickAwayListener onClickAway={() => {}}>
                    <MenuList autoFocusItem={open} id="menu-list-grow-mobile" onKeyDown={handleListKeyDown}>
                      <StandardMenuItem
                        label="Home"
                        action={(e) => handleClose(e, '/dashboard')}
                        isMobile
                      />

                      {isPartner(effectiveUser) && (
                        <StandardMenuItem
                          label={`Switch to ${isPartnerCustomerMode ? 'partner' : 'customer'} view`}
                          action={(e) => {
                            setOpen(false);
                            if (!isPartnerCustomerMode) localStorage.setItem('PARTNERS-CUSTOMER-MODE', 'true');
                            else localStorage.removeItem('PARTNERS-CUSTOMER-MODE');
                            dispatch(setIsPartnerCustomerMode(!isPartnerCustomerMode));
                            handleClose(e, '/dashboard');
                          }}
                          isMobile
                        />
                      )}

                      {/*{!!isActivityNavigationItemRendered && (
                        <StandardMenuItem
                          label="Activity"
                          icon={<WorkHistoryIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/journeys-activity'); }}
                          link="/journeys-activity"
                          isMobile
                          topIconPos="5px"
                        />
                      )}
                      {!!isActionsNavigationItemRendered && (
                        <StandardMenuItem
                          label="Actions"
                          icon={<ListAltIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/actions'); }}
                          link="/actions"
                          isMobile
                          topIconPos="5px"
                        />
                      )}*/}
                      {!!isCustomersNavigationItemRendered && (
                        <StandardMenuItem
                          label="Customers"
                          icon={<PeopleOutlinedIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/customers-dashboard'); }}
                          link="/customers-dashboard"
                          isMobile
                          topIconPos="5px"
                        />
                      )}
                      {!!isJourneysNavigationItemRendered && (
                        <StandardMenuItem
                          label="Journeys"
                          icon={<AvTimerOutlinedIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, isEffectivelyCustomer ? '/journeys' : '/journeys-dashboard'); }}
                          link={isEffectivelyCustomer ? '/journeys' : '/journeys-dashboard'}
                          isMobile
                          topIconPos="6px"
                        />
                      )}
                      {!!isDocumentsNavigationItemRendered && (
                        <StandardMenuItem
                          label="Documents"
                          icon={<LibraryBooksIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/documents'); }}
                          link="/documents"
                          isMobile
                          topIconPos="5px"
                        />
                      )}
                      {!!isTeamNavigationItemRendered && (
                        <StandardMenuItem
                          label="Team"
                          icon={<PeopleOutlinedIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/team'); }}
                          link="/team"
                          isMobile
                          topIconPos="5px"
                        />
                      )}

                      {(userRole === USER_ROLE.Customer && !!isFeatureEnabled(featureFlags, 'isReferFriendsInvitesActive')) && (
                        <StandardMenuItem
                          label="Refer a friend"
                          icon={<CardGiftcardIcon />}
                          action={(e) => { e.preventDefault(); handleReferringAFriend(e); }}
                          isMobile
                          topIconPos="2px"
                        />
                      )}

                      {!!isActionsNavigationItemRendered && (
                        <NestedMenuItem
                          className={`${styles.nestedMenuItemMobile}`}
                          disableRipple
                          disableTouchRipple
                          onClick={() => {}}
                          label={<><span style={{ marginRight: '8px', position: 'relative', top: '4px' }}><WorkHistoryIcon /></span>Workflow</>}
                          parentMenuOpen={!!open}
                          data-testid={`menuitem-user-menu-main-header-mobile-workflow`}
                          ContainerProps={touchOpenContainerProps}
                        >
                          <StandardMenuItem
                            label="Actions"
                            action={(e) => { e.preventDefault(); handleClose(e, '/actions'); }}
                            link="/actions"
                            isMobile
                            isNested
                          />
                          <StandardMenuItem
                            label="Activity"
                            action={(e) => { e.preventDefault(); handleClose(e, '/journeys-activity'); }}
                            link="/journeys-activity"
                            isMobile
                            isNested
                          />
                        </NestedMenuItem>
                      )}

                      {mode === 'specialist' && (<>
                        <NestedMenuItem
                          className={`${styles.nestedMenuItemMobile}`}
                          disableRipple
                          disableTouchRipple
                          onClick={() => {}}
                          label={<><span style={{ marginRight: '8px', position: 'relative', top: '4px' }}><DashboardIcon /></span>Utilities</>}
                          parentMenuOpen={!!open}
                          data-testid={`menuitem-user-menu-main-header-mobile-utilities`}
                          ContainerProps={touchOpenContainerProps}
                        >
                          <StandardMenuItem
                            label="Deals finder"
                            action={(e) => { e.preventDefault(); handleClose(e, '/find-deals/find-deal-specialist'); }}
                            link="/find-deals/find-deal-specialist"
                            isMobile
                            isNested
                          />
                          {!isJustDataOperations(effectiveUser) && (
                            <StandardMenuItem
                              label="Property reports"
                              action={(e) => { e.preventDefault(); handleClose(e, '/property-reports'); }}
                              link="/property-reports"
                              isMobile
                              isNested
                            />
                          )}
                        </NestedMenuItem>
                        <NestedMenuItem
                          className={`${styles.nestedMenuItemMobile}`}
                          disableRipple
                          disableTouchRipple
                          onClick={() => {}}
                          label={<><span style={{ marginRight: '8px', position: 'relative', top: '5px' }}><CalculateOutlinedIcon /></span>Calculators</>}
                          parentMenuOpen={!!open}
                          data-testid={`menuitem-user-menu-main-header-mobile-calculators`}
                          ContainerProps={touchOpenContainerProps}
                        >
                          <StandardMenuItem
                            label="Stamp duty calculator"
                            action={(e) => { e.preventDefault(); handleClose(e, '/calculators/stamp-duty'); }}
                            link="/calculators/stamp-duty"
                            isMobile
                            isNested
                          />
                          <StandardMenuItem
                            label="Loan repayment calculator"
                            action={(e) => { e.preventDefault(); handleClose(e, '/calculators/loan-repayment'); }}
                            link="/calculators/loan-repayment"
                            isMobile
                            isNested
                          />
                          <StandardMenuItem
                            label="Extra repayment calculator"
                            action={(e) => { e.preventDefault(); handleClose(e, '/calculators/extra-repayment'); }}
                            link="/calculators/extra-repayment"
                            isMobile
                            isNested
                          />
                          <StandardMenuItem
                            label="Income tax calculator"
                            action={(e) => { e.preventDefault(); handleClose(e, '/calculators/income-taxes'); }}
                            link="/calculators/income-taxes"
                            isMobile
                            isNested
                          />
                          <StandardMenuItem
                            label="Offset account calculator"
                            action={(e) => { e.preventDefault(); handleClose(e, '/calculators/offset-account'); }}
                            link="/calculators/offset-account"
                            isMobile
                            isNested
                          />
                          <StandardMenuItem
                            label="Equity calculator"
                            action={(e) => { e.preventDefault(); handleClose(e, '/calculators/equity-calculator'); }}
                            link="/calculators/equity-calculator"
                            isMobile
                            isNested
                          />
                          <StandardMenuItem
                            label="Rate change calculator"
                            action={(e) => { e.preventDefault(); handleClose(e, '/calculators/rate-change-calculator'); }}
                            link="/calculators/rate-change-calculator"
                            isMobile
                            isNested
                          />
                        </NestedMenuItem>
                      </>)}

                      {(!!isOpenNextGenRendered || !!isLendersRendered || !!isDealsManagementRendered) && (<>
                        <NestedMenuItem
                          className={`${styles.nestedMenuItemMobile}`}
                          disableRipple
                          disableTouchRipple
                          onClick={() => {}}
                          label={<><span style={{ marginRight: '8px', position: 'relative', top: '5px' }}><PermDataSettingIcon /></span>Services</>}
                          parentMenuOpen={!!open}
                          data-testid={`menuitem-user-menu-main-header-mobile-services`}
                          ContainerProps={touchOpenContainerProps}
                        >
                          {!!isOpenNextGenRendered && (
                            <StandardMenuItem
                              label="Open NextGen"
                              action={(e) => { goToNextGenPage(e); }}
                              isMobile
                              isNested
                            />
                          )}
                          {!!isLendersRendered && (
                            <StandardMenuItem
                              label="Lenders"
                              action={(e) => { e.preventDefault(); handleClose(e, '/lenders'); }}
                              link="/lenders"
                              isMobile
                              isNested
                            />
                          )}
                          {!!isDealsManagementRendered && (
                            <StandardMenuItem
                              label="Deals management"
                              action={(e) => { e.preventDefault(); handleClose(e, '/deals-management'); }}
                              link="/deals-management"
                              isMobile
                              isNested
                            />
                          )}
                        </NestedMenuItem>
                      </>)}


                      {!!isAccountAndTeamRendered && (
                        <StandardMenuItem
                          label="Account & Team"
                          icon={<SupervisorAccountIcon />}
                          action={(e) => { e.preventDefault(); handleClose(e, '/partner-account-edit'); }}
                          link="/partner-account-edit"
                          isMobile
                          topIconPos="6px"
                        />
                      )}
                      {!!isAccountsRendered && (
                        <>
                          <StandardMenuItem
                            label="Accounts"
                            icon={<SupervisorAccountIcon />}
                            action={(e) => { e.preventDefault(); handleClose(e, '/accounts'); }}
                            link="/accounts"
                            isMobile
                            topIconPos="6px"
                          />
                          <StandardMenuItem
                            label="Users"
                            icon={<PeopleOutlinedIcon />}
                            action={(e) => { e.preventDefault(); handleClose(e, '/users'); }}
                            link="/users"
                            isMobile
                            topIconPos="6px"
                          />
                        </>
                      )}

                      <StandardMenuItem
                        label="Profile"
                        icon={<PersonOutlineIcon />}
                        action={(e) => { e.preventDefault(); handleClose(e, '/profile'); }}
                        link="/profile"
                        isMobile
                        topIconPos="5px"
                      />
                      <StandardMenuItem
                        label="Log Out"
                        action={(e) => { setOpen(false); dispatch(logOut({})); handleClose(e); }}
                        isMobile
                      />
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </AppBar>
        {headerType !== 'registrationWizard' && !!user && !isJustDataOperations(effectiveUser) && !isJustDataOperations(user) && (
          <ReferFriendModal setOpen={setOpenReferFriendModal} open={openReferFriendModal} retrieveOnMount={headerType !== 'registrationWizard' && !!user && !isJustDataOperations(effectiveUser) && !isJustDataOperations(user)} />
        )}
      </>
  )
};

export default withRouter(MainHeader);
